import * as types from "../types";
import axios from "axios";

axios.defaults.headers.common["Content-Type"] = "application/json";
axios.defaults.headers.common["Authorization"] = "Bearer " + localStorage.token;

const API_COUPON_LIST = types.API_BASE_URL + "coupon/manage/list";
const API_COUPON_NEW = types.API_BASE_URL + "coupon/create";
const API_COUPON_DETAIL = types.API_BASE_URL + "coupon/manage/detail";
const API_COUPON_UPDATE = types.API_BASE_URL + "coupon/update";
const API_COUPON_DELETE = types.API_BASE_URL + "coupon/delete";

const state = {};

const getters = {};

const mutations = {};

const actions = {
  [types.GET_COUPON_LIST]: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      axios
        .get(API_COUPON_LIST, payload)
        .then(response => {
          if (response.data.status == 200) {
            resolve(response.data.data);
          } else {
            reject(response.data.messages);
          }
        })
        .catch(error => {
          if (error.response.status == 401) {
            commit(types.MUTATE_LOGOUT);
            reject(error.message);
          } else {
            reject(error.message);
          }
        });
    });
  },
  [types.SET_NEW_COUPON]: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      axios
        .post(API_COUPON_NEW, payload)
        .then(response => {
          if (response.data.status == 200) {
            resolve(response.data.data);
          } else {
            reject(response.data.messages);
          }
        })
        .catch(error => {
          if (error.response.status == 401) {
            commit(types.MUTATE_LOGOUT);
            reject(error.message);
          } else {
            reject(error.message);
          }
        });
    });
  },

  [types.GET_COUPON_DETAIL]: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      axios
        .get(API_COUPON_DETAIL + "/" + payload)
        .then(response => {
          if (response.data.status == 200) {
            resolve(response.data.data[0]);
          } else {
            reject(response.data.messages);
          }
        })
        .catch(error => {
          if (error.response.status == 401) {
            commit(types.MUTATE_LOGOUT);
            reject(error.message);
          } else {
            reject(error.message);
          }
        });
    });
  },

  [types.UPDATE_COUPON]: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      axios
        .post(API_COUPON_UPDATE, payload)
        .then(response => {
          if (response.data.status == 200) {
            resolve(response.data.data);
          } else {
            reject(response.data.messages);
          }
        })
        .catch(error => {
          if (error.response.status == 401) {
            commit(types.MUTATE_LOGOUT);
            reject(error.message);
          } else {
            reject(error.message);
          }
        });
    });
  },

  [types.DELETE_COUPON]: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      axios
        .post(API_COUPON_DELETE, payload)
        .then(response => {
          if (response.data.status == 200) {
            resolve(response.data.data);
          } else {
            reject(response.data.messages);
          }
        })
        .catch(error => {
          if (error.response.status == 401) {
            commit(types.MUTATE_LOGOUT);
            reject(error.message);
          } else {
            reject(error.message);
          }
        });
    });
  },
};

export default {
  state,
  mutations,
  actions,
  getters
};
